import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {VisualiserMessages} from 'src/app/modules/shared/models/component-messages/visualiser-messages';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-popup-supprimer',
  templateUrl: './popup-supprimer.component.html'
})
export class PopupSupprimerComponent implements OnInit {
  @Input() idAvis: any;
  public visualiserMessages = new VisualiserMessages();
  public referenceAvis: string;
  @Output() confirm = new EventEmitter<void>();


  constructor(
    public activeModal: NgbActiveModal,
  ) {
  }

  public ngOnInit() {
  }

  public supprimerAvis() {
    this.confirm.emit();
    this.activeModal.close();
  }
}
